import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentsBase } from '@routes/tickets/ticket-edit/contents/contents-base';
import { Customer } from '@shared/models/customer';
import { finalize, takeWhile } from 'rxjs/operators';
import { TicketCreate } from '@shared/models/ticket-create';
import Utils from '@shared/utils/utils';
import { CustomerSearchComponent } from '@routes/dialogs/customer-search/customer-search.component';
import { CONTENT_STEP } from '@routes/tickets/ticket-edit/contents/contents-steps';
import { Basic } from '@shared/models/basic';
import Swal from 'sweetalert2';
import { Company } from '@shared/enums/company';
import { Constants } from '@shared/constants/constants';
import { DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent extends ContentsBase implements OnInit, OnDestroy {

  customer: Customer = {};
  basic: Basic = {};
  customerType;
  showCustomerSearch = true;
  companies = Company;
  addressOptions: any[];

  pipe = new DatePipe('en-US');
  detailForm: FormGroup;
  currentCustomer;
  currentUser;
  selectedAddress;
  customerOriginalAddress;
  addressExist: boolean;
  storeBpNo: string;

  async ngOnInit(): Promise<void> {
    this.init('customer');

    this.ticketService.data$
      .pipe(takeWhile(() => this.alive))
      .subscribe((ticket: TicketCreate) => {
        if (Utils.isEmpty(ticket)) {
          return;
        }
        ['basic', 'customer'].forEach(x => {
          this[x] = ticket[x];
        });

        if ([Company.SeaIm].includes(this.company) && this.customer?.bpNo && this.basic?.dealer?.bpNo && (this.customer.bpNo !== this.basic.dealer.bpNo)) {
          this.customer.bpNo = this.basic.dealer.bpNo
          this.updateDealerContact(this.customer.email, this.basic.dealer.bpNo);
        }
      });
    // Set Customer for SEA_IM (C370)
    if (!this.isDetail && [Company.SeaIm].includes(this.company)) {
      this.customerType = Constants.customerType.STORE;
      if (this.isDealerStaff || this.isDealerManager) {
        this.showCustomerSearch = false;
        this.dealerContactSearchForSeaMX();
      }
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  updateDealerContact(contactEmail, dealerBpNo) {
    this.spinnerService.start();
    this.apiService.dealer.getDealer(dealerBpNo)
      .subscribe(res => {
        let dealerContact;
        res.contacts.map(contact => {
          if (contact.email === contactEmail) {
            dealerContact = contact;
          }
        });
        dealerContact.employeeNo = dealerBpNo;
        this.apiService.dealer.updateContact(dealerBpNo, dealerContact._id, dealerContact)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(res => {
          }, err => Utils.showError(err));
      }, err => Utils.showError(err));
  }

  customerSearch() {
    const { dealer } = this.basic;
    if (!dealer?.dealer || !dealer?.dealerStore) {
      Swal.fire({
        icon: 'info',
        title: 'Please Dealer Information choice. ',
        showConfirmButton: true,
      });
      return;
    }

    const initialState = {
      title: 'Customer Search',
      customerType: [Company.SeaIm].includes(this.company) ? this.customerType : this.basic.customerType,
      // customerType: this.basic.customerType,
      bpNo: this.basic.dealer.bpNo,
    };

    this.bsModalRef = this.modalService.show(CustomerSearchComponent, {
      class: 'modal-customer-search',
      initialState,
    });

    this.bsModalRef.content.onClose.subscribe(async res => {
      console.log('>>>>>>>>>>>>>>> res = ', JSON.stringify(res));
      if (this.basic.customerType === Constants.customerType.CUSTOMER) {
        this.currentUser = await this.authService.getUser();
        await new Promise<void>((resolve, reject) => {
          this.apiService.user.getUser(this.currentUser.username).subscribe(
            (res) => {
              const fullAddress =
                this.addressOptions = res.favoriteAddress?.map((address) => ({
                  ...address,
                  fullAddress: `${ address.address2 ? `${ address.address2 }, ` : '' }${ address.address1 }, ${ address.city }, ${ address.state }, ${ address.zipcode }${ address.country ? `, ${ address.country }` : '' }`
                }));
              resolve();
            },
            (error) => {
              this.addressOptions = [];
              reject(error);
            }
          );
        });
      }

      if (this.basic.customerType === Constants.customerType.STORE) {
        this.storeBpNo = res?.bpNo
        await new Promise<void>((resolve, reject) => {
          this.apiService.dealer.getDealer(this.storeBpNo).subscribe(
            (res) => {
              this.addressOptions = res.favoriteAddress?.map((address) => ({
                ...address,
                fullAddress: `${ address.address2 ? `${ address.address2 }, ` : '' }${ address.address1 }, ${ address.city }, ${ address.state }, ${ address.zipcode }${
                  address.country ? `, ${ address.country }` : ''
                }`
              }));
              resolve();
            },
            (error) => {
              this.addressOptions = [];
              reject(error);
            }
          );
        });
      }


      let data: any = {
        customer: res
      }

      this.currentCustomer = data;
      const currentAddress = {
        ...data.customer.address,
        fullAddress: `${ data.customer.address.address2 ? `${ data.customer.address.address2 }, ` : '' }${ data.customer.address.address1 }, ${ data.customer.address.city }, ${ data.customer.address.state }, ${ data.customer.address.zipcode }${ data.customer.address.country ? `, ${ data.customer.address.country }` : '' }`
      }
      this.selectedAddress = currentAddress;
      if (!this.addressOptions) {
        this.addressOptions = [];
      }
      const exists = this.addressOptions?.some((item) =>
        item.address1 === data.customer.address.address1 &&
        item.address2 === data.customer.address.address2 &&
        item.city === data.customer.address.city &&
        item.zipcode === data.customer.address.zipcode &&
        item.country === data.customer.address.country
      )
      if (exists) {
        this.addressExist = true;
      } else {
        this.addressExist = false;
        this.addressOptions.push(currentAddress);
      }
      this.setCustomer(data)
    });
  }

  dealerContactSearchForSeaMX() {
    const currentUser = this.authService.getUser();

    this.apiService.dealer.getDealer(currentUser?.organization)
      .pipe()
      .subscribe(store => {
          const user = this.apiService.user.getUser(currentUser?.username)
            .pipe()
            .subscribe(user => {
              const data = {
                customer: {
                  firstName: user.firstName,
                  lastName: user.lastName,
                  bpNo: user.employeeNo,
                  address: store.address,
                  cellPhone: store.mainCon,
                  homePhone: user.tel,
                  workPhone: user.tel,
                  workExtension: '',
                  email: user.username,
                  company: this.company,
                  contactId: store.contacts.find(contact => contact.email === user.username)?._id || '',
                  contact: {
                    code: '1',
                    name: 'Contact allowed'
                  }
                }
              }
              this.setCustomer(data);
            });
        }
      )
  }

  setCustomer(customer) {
    this.isTabEditor();
    this.ticketService.patch(customer, 'Customer');
    this.customerOriginalAddress = this.customer?.address;
    this.ticketService.goNext(CONTENT_STEP.PRODUCT);
  }

  setTicketAddress($event) {
    if (this.basic.customerType === Constants.customerType.CUSTOMER) {
      this.currentUser = this.authService.getUser();
      this.apiService.user.getUser(this.currentUser.username).subscribe(
        (res) => {
          this.addressExist = res.favoriteAddress.some(item =>
            item.address1 === $event.address1 &&
            item.address2 === $event.address2 &&
            item.city === $event.city &&
            item.zipcode === $event.zipcode &&
            item.country === $event.country
          )
        })
    }

    if (this.basic.customerType === Constants.customerType.STORE) {
      this.apiService.dealer.getDealer(this.storeBpNo).subscribe(
        (res) => {
          this.addressExist = res.favoriteAddress.some(item =>
            item.address1 === $event.address1 &&
            item.address2 === $event.address2 &&
            item.city === $event.city &&
            item.zipcode === $event.zipcode &&
            item.country === $event.country
          )
        })
    }
    this.currentCustomer.customer.address = {
      address1: this.selectedAddress.address1,
      address2: this.selectedAddress.address2,
      city: this.selectedAddress.city,
      state: this.selectedAddress.state,
      zipcode: this.selectedAddress.zipcode,
      country: this.selectedAddress.country || 'US'
    }
    this.ticketService.patch(this.currentCustomer, 'Customer')
    this.ticketService.goNext(CONTENT_STEP.PRODUCT);
  }


  async addFavoriteAddress() {
    if (this.basic.customerType === Constants.customerType.CUSTOMER) {
      await this.apiService.user.saveUserAddressFavorite(this.currentUser, this.selectedAddress).subscribe(res => {
        this.addressOptions = res.favoriteAddress.map((address) => ({
          ...address,
          fullAddress: `${ address.address1 }, ${ address.city }, ${ address.state }, ${ address.zipcode }${ address.country ? `, ${ address.country }` : '' }`
        }));
        this.isAddressExists()
        this.addressExist = true;
      });
    }
    if (this.basic.customerType === Constants.customerType.STORE) {
      await this.apiService.dealer.saveDealerAddressFavorite(this.storeBpNo, this.selectedAddress).subscribe(res => {
        this.addressOptions = res.favoriteAddress.map((address) => ({
          ...address,
          fullAddress: `${ address.address1 }, ${ address.city }, ${ address.state }, ${ address.zipcode }${ address.country ? `, ${ address.country }` : '' }`
        }));
        this.isAddressExists()
        this.addressExist = true;
      });
    }
  }

  isAddressExists() {
    const isAddressExists = this.addressOptions.some(item =>
      item.address1 === this.customerOriginalAddress.address1 &&
      item.address2 === this.customerOriginalAddress.address2 &&
      item.city === this.customerOriginalAddress.city &&
      item.zipcode === this.customerOriginalAddress.zipcode &&
      item.country === this.customerOriginalAddress.country
    )
    if (!isAddressExists) {
      this.addressOptions.push({
        ...this.customerOriginalAddress,
        fullAddress: `${ this.customerOriginalAddress.address1 }, ${ this.customerOriginalAddress.city }, ${ this.customerOriginalAddress.state }, ${ this.customerOriginalAddress.zipcode }${
          this.customerOriginalAddress.country ? `, ${ this.customerOriginalAddress.country }` : ''
        }`
      });
    }
  }

  async deleteFavoriteAddress() {
    if (this.basic.customerType === Constants.customerType.CUSTOMER) {
      await this.apiService.user.deleteUserAddressFavorite(this.currentUser, this.selectedAddress).subscribe(res => {
        this.addressOptions = res.favoriteAddress.map((address) => ({
          ...address,
          fullAddress: `${ address.address1 }, ${ address.city }, ${ address.state }, ${ address.zipcode }${ address.country ? `, ${ address.country }` : '' }`
        }));

        this.isAddressExists()
        this.addressExist = false;
      });
    }

    if (this.basic.customerType === Constants.customerType.STORE) {
      await this.apiService.dealer.deleteDealerAddressFavorite(this.storeBpNo, this.selectedAddress).subscribe(res => {
        this.addressOptions = res.favoriteAddress.map((address) => ({
          ...address,
          fullAddress: `${ address.address1 }, ${ address.city }, ${ address.state }, ${ address.zipcode }${ address.country ? `, ${ address.country }` : '' }`
        }));

        this.isAddressExists()
        this.addressExist = false;
      });
    }
  }
}
